import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { useAuth } from '../../../../context/AuthContext';
import LoginCard from './components/LoginCard';
import DemoCredentialsCard from './components/DemoCredentialsCard';
import HexagonDecoration from './components/HexagonDecoration';
import LanguageSwitcher from '../../../../i18n/LanguageSwitcher';
import { isScannerDevice } from '../../../../services/scannerSession';

export default function LoginPage() {
  const { isAuthenticated, isLoading } = useAuth();
  const [departmentName, setDepartmentName] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  // Get the 'from' location from state, default to '/home' if not provided
  const from = location.state?.from?.pathname || '/home';
  const redirect_infoscreen = location.state?.redirect_infoscreen ?? true;

  useEffect(() => {
    const storedData = localStorage.getItem('orbit_perm_infoscreen');
    if (storedData && redirect_infoscreen) {
      navigate('/infoscreens/show');
      return;
    }
    if (isScannerDevice() && redirect_infoscreen) {
      navigate('/scanner');
    }
  }, [navigate, redirect_infoscreen])


  // Redirect if already authenticated
  if (!isLoading && isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: '100vh',
        backgroundImage: 'url(/images/pexels-barnabas-davoti-31615494-10832593_01.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 3,
        px: { xs: 2, sm: 4 },
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          zIndex: 1,
        }
      }}
    >
      <HexagonDecoration position="top-left" />
      <HexagonDecoration position="bottom-right" />
      <Box sx={{ position: 'absolute', top: 16, right: 16, zIndex: 10, bgcolor: 'background.paper', borderRadius: 0.5 }}>
        <LanguageSwitcher />
      </Box>
      <Box
        sx={{
          position: 'relative',
          zIndex: 3,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'stretch', md: 'flex-start' },
          gap: 3,
        }}
      >
        <LoginCard onDepartmentChange={setDepartmentName} />
        <DemoCredentialsCard departmentName={departmentName} />
      </Box>
    </Box>
  );
}